import { useContext } from "react";

import { TableCallContext } from "./table-call.context.js";

export const useTableCall = () => {
  const context = useContext(TableCallContext);

  if (!context.__ctx_init) {
    throw new Error("useTableCall has to be used inside TableCallProvider");
  }

  return context;
};
